// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   STEPPER (bm-stepper) - CENTRADO Y SIN SOLAPES
   ============================================ */

.bm-stepper {
  /* ✅ en vez de fixed: se mantiene arriba, pero NO sale del flujo */
  position: sticky;
  top: 0;

  z-index: 5;
  background: #fff;

  /* “card look” */
  padding: 18px 16px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0,0,0,.12);

  /* ✅ centrado perfecto dentro del dialog */
  width: calc(100% - 40px);
  max-width: 980px;
  margin: 18px auto 18px auto;

  /* layout interno */
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;

  user-select: none;
}

/* ✅ IMPORTANTE: si tu dialog content tiene overflow, sticky necesita esto */
md-dialog-content,
.bm-dialog-content {
  position: relative;
  overflow-y: auto;
}

/* Ya NO hace falta compensar el contenido por padding-top para fixed */
/* Dejalo en 0 para evitar espacios raros */
.bm-dialog-content {
  padding-top: 0 !important;
}

.bm-dialog-content > * {
  margin-top: 0 !important;
}

/* ============================================
   Pasos / Estados (mantengo tu look rosa)
   ============================================ */

.bm-stepper .bm-step {
  position: relative;
  display: flex;
  align-items: center;
  color: #9e9e9e;
}

.bm-stepper .bm-step .circle {
  width: 34px;
  height: 34px;
  min-width: 34px;
  min-height: 34px;
  border-radius: 50%;
  border: 2px solid #ec407a;
  color: #ec407a;
  background: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  margin-right: 10px;
  padding: 0;
  transition: background .2s ease, color .2s ease, border-color .2s ease, box-shadow .2s ease;
}

.bm-stepper .bm-step .circle.clickable:hover {
  background: #ffe6ef;
  box-shadow: 0 2px 8px rgba(236, 64, 122, 0.25);
}

.bm-stepper .bm-step .label {
  font-weight: 600;
  color: #333;
  white-space: nowrap;
  margin-right: 16px;
}

.bm-stepper .bm-step.is-active .circle {
  background: #ec407a;
  color: #fff;
  border-color: #ec407a;
}

.bm-stepper .bm-step.is-completed .circle {
  background: #f06292;
  color: #fff;
  border-color: #f06292;
}

/* Conector */
.bm-stepper .connector {
  width: 80px;
  height: 4px;
  background: #f3bfd0;
  border-radius: 2px;
  overflow: hidden;
  margin-left: 12px;
  margin-right: 4px;
}

.bm-stepper .connector .bar {
  height: 100%;
  background: #ec407a;
  border-radius: 2px;
  width: 0%;
  transition: width .25s ease;
}

/* md-icon dentro del círculo */
.bm-stepper .bm-step .circle md-icon {
  font-size: 18px;
  line-height: 18px;
  width: 18px;
  height: 18px;
}
`, "",{"version":3,"sources":["webpack://./common/stepper/bmStepper.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD;EACE,kEAAkE;EAClE,gBAAgB;EAChB,MAAM;;EAEN,UAAU;EACV,gBAAgB;;EAEhB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;;EAEtC,0CAA0C;EAC1C,wBAAwB;EACxB,gBAAgB;EAChB,2BAA2B;;EAE3B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;;EAET,iBAAiB;AACnB;;AAEA,4EAA4E;AAC5E;;EAEE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,uEAAuE;AACvE,2CAA2C;AAC3C;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;iDAEiD;;AAEjD;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,2FAA2F;AAC7F;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA,aAAa;AACb;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,2BAA2B;AAC7B;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd","sourcesContent":["/* ============================================\n   STEPPER (bm-stepper) - CENTRADO Y SIN SOLAPES\n   ============================================ */\n\n.bm-stepper {\n  /* ✅ en vez de fixed: se mantiene arriba, pero NO sale del flujo */\n  position: sticky;\n  top: 0;\n\n  z-index: 5;\n  background: #fff;\n\n  /* “card look” */\n  padding: 18px 16px;\n  border-radius: 10px;\n  box-shadow: 0 4px 12px rgba(0,0,0,.12);\n\n  /* ✅ centrado perfecto dentro del dialog */\n  width: calc(100% - 40px);\n  max-width: 980px;\n  margin: 18px auto 18px auto;\n\n  /* layout interno */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n\n  user-select: none;\n}\n\n/* ✅ IMPORTANTE: si tu dialog content tiene overflow, sticky necesita esto */\nmd-dialog-content,\n.bm-dialog-content {\n  position: relative;\n  overflow-y: auto;\n}\n\n/* Ya NO hace falta compensar el contenido por padding-top para fixed */\n/* Dejalo en 0 para evitar espacios raros */\n.bm-dialog-content {\n  padding-top: 0 !important;\n}\n\n.bm-dialog-content > * {\n  margin-top: 0 !important;\n}\n\n/* ============================================\n   Pasos / Estados (mantengo tu look rosa)\n   ============================================ */\n\n.bm-stepper .bm-step {\n  position: relative;\n  display: flex;\n  align-items: center;\n  color: #9e9e9e;\n}\n\n.bm-stepper .bm-step .circle {\n  width: 34px;\n  height: 34px;\n  min-width: 34px;\n  min-height: 34px;\n  border-radius: 50%;\n  border: 2px solid #ec407a;\n  color: #ec407a;\n  background: #fff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  margin-right: 10px;\n  padding: 0;\n  transition: background .2s ease, color .2s ease, border-color .2s ease, box-shadow .2s ease;\n}\n\n.bm-stepper .bm-step .circle.clickable:hover {\n  background: #ffe6ef;\n  box-shadow: 0 2px 8px rgba(236, 64, 122, 0.25);\n}\n\n.bm-stepper .bm-step .label {\n  font-weight: 600;\n  color: #333;\n  white-space: nowrap;\n  margin-right: 16px;\n}\n\n.bm-stepper .bm-step.is-active .circle {\n  background: #ec407a;\n  color: #fff;\n  border-color: #ec407a;\n}\n\n.bm-stepper .bm-step.is-completed .circle {\n  background: #f06292;\n  color: #fff;\n  border-color: #f06292;\n}\n\n/* Conector */\n.bm-stepper .connector {\n  width: 80px;\n  height: 4px;\n  background: #f3bfd0;\n  border-radius: 2px;\n  overflow: hidden;\n  margin-left: 12px;\n  margin-right: 4px;\n}\n\n.bm-stepper .connector .bar {\n  height: 100%;\n  background: #ec407a;\n  border-radius: 2px;\n  width: 0%;\n  transition: width .25s ease;\n}\n\n/* md-icon dentro del círculo */\n.bm-stepper .bm-step .circle md-icon {\n  font-size: 18px;\n  line-height: 18px;\n  width: 18px;\n  height: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
